/**
 * i18n Configuration
 * Defines supported locales and their settings
 */

export const SUPPORTED_LOCALES = {
  'en-US': {
    label: 'English (US)',
    dateFormat: 'MM/dd/yyyy',
    timeFormat: '12h',
    firstDayOfWeek: 0, // Sunday
  },
  'en-GB': {
    label: 'English (UK)',
    dateFormat: 'dd/MM/yyyy',
    timeFormat: '24h',
    firstDayOfWeek: 1, // Monday
  },
} as const

export type SupportedLocale = keyof typeof SUPPORTED_LOCALES
export type DateFormatType = 'MM/dd/yyyy' | 'dd/MM/yyyy' | 'yyyy-MM-dd'
export type TimeFormatType = '12h' | '24h'

export const DEFAULT_LOCALE: SupportedLocale = 'en-US'

export const FALLBACK_LOCALE = 'en-US'

/**
 * i18next configuration options
 */
export const I18N_CONFIG = {
  defaultNS: 'common',
  fallbackNS: 'common',
  fallbackLng: FALLBACK_LOCALE,
  supportedLngs: ['en-US', 'en-GB', 'en'], // Include 'en' for browser default

  // Language detection - allow 'en' to fallback to 'en-US'
  load: 'languageOnly' as const,
  nonExplicitSupportedLngs: true,

  // Debugging (disable in production)
  debug: import.meta.env.DEV,

  // Interpolation options
  interpolation: {
    escapeValue: false, // React already escapes
  },

  // React specific
  react: {
    useSuspense: false, // Disable suspense for now
  },
} as const

/**
 * Available namespaces
 */
export const NAMESPACES = [
  'common',      // Shared UI elements
  'tasks',       // Task management
  'labels',      // Label management
  'settings',    // Settings pages
  'navigation',  // Navigation items
  'validation',  // Error messages
  'auth',        // Authentication
  'projects',    // Project management
  'notes',       // Personal notes (daily/weekly)
  'home',        // Workspace Home
  'notifications', // Notifications inbox
] as const

export type Namespace = (typeof NAMESPACES)[number]
